var map = {
	"./ball.svg": 64152,
	"./boat.svg": 92922,
	"./dot.svg": 19204,
	"./flower.svg": 98574,
	"./gear.svg": 75838,
	"./heart.svg": 55869,
	"./moon.svg": 69684,
	"./star.svg": 75111,
	"./sun.svg": 58311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56979;